// extracted by mini-css-extract-plugin
module.exports = {"root":"BookingTimeInfo_root__3fMIB","bookingInfo":"BookingTimeInfo_bookingInfo__10D5K","dateSection":"BookingTimeInfo_dateSection___w50j"};